<template>
  <div class="login-container">
    <div class="login-box">
      <div style="text-align: center;font-size: 24px;font-weight: bold;color: #42b983;margin-bottom: 20px;">东东助手</div>
      <form @submit.prevent="handleLogin" class="login-form" autocomplete="on">
        <!-- 隐藏的原生input元素，帮助浏览器识别表单结构 -->
        <input type="text" style="display: none;" autocomplete="username" />
        <input type="password" style="display: none;" autocomplete="current-password" />

        <div class="form-group">
          <el-input id="positionId" v-model="loginForm.positionId" type="text" placeholder="请输入ID或手机号"
            prefix-icon="el-icon-user" required clearable autocomplete="username" name="positionId" />
        </div>
        <div class="form-group">
          <el-input id="password" v-model="loginForm.password" type="password" placeholder="请输入密码"
            prefix-icon="el-icon-lock" required clearable show-password autocomplete="current-password"
            name="password" />
        </div>
        <!-- 修改密码表单 -->
        <div v-if="showChangePassword" class="change-password-section">
          <div class="form-group">
            <label for="newPassword">新密码</label>
            <el-input id="newPassword" v-model="changePasswordForm.newPassword" type="password" placeholder="请输入新密码"
              required clearable show-password />
          </div>
          <div class="form-group">
            <label for="confirmPassword">确认新密码</label>
            <el-input id="confirmPassword" v-model="changePasswordForm.confirmPassword" type="password"
              placeholder="请再次输入新密码" required clearable show-password />
          </div>
        </div>

        <div class="form-group remember-group">
          <label class="remember-label">
            <input type="checkbox" v-model="rememberPassword" class="remember-checkbox" />
            记住密码
          </label>
          <label class="remember-label change-password-label" @click="toggleChangePassword">
            <span class="remember-text">{{ showChangePassword ? '取消修改密码' : '修改密码' }}</span>
          </label>
        </div>

        <button type="submit" :disabled="loading" class="login-btn">
          {{ loading ? '登录中...' : (showChangePassword ? '修改并登录' : '登录') }}
        </button>
      </form>

      <div v-if="message" :class="['message', messageType]">
        {{ message }}
      </div>

      <!-- 注册链接 -->
      <div class="register-link">
        <span>还没有账号？</span>
        <el-button type="text" @click="goToRegister">立即注册</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { login, changePassword } from '@/utils/jdApi'

export default {
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      message: '',
      messageType: '',
      rememberPassword: true, // 默认勾选记住密码
      showChangePassword: false,
      loginForm: {
        positionId: '',
        password: ''
      },
      changePasswordForm: {
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  mounted() {
    // 页面加载时检查是否有保存的登录信息
    this.loadSavedCredentials()
  },
  methods: {
    async handleLogin() {
      if (this.showChangePassword) {
        await this.handleChangePassword()
      } else {
        await this.performLogin()
      }
    },
    async performLogin() {
      this.loading = true
      this.message = ''

      try {
        // 登录 - 使用推广ID和密码
        const account = (this.loginForm.positionId || '').trim()
        if (!account) {
          this.showMessage('请输入推广ID或手机号', 'error')
          this.loading = false
          return
        }
        let payload = {
          positionId: '',
          phone: '',
          password: this.loginForm.password
        }
        const phonePattern = /^1[3-9]\d{9}$/
        if (phonePattern.test(account)) {
          payload.phone = account
        } else {
          payload.positionId = account
        }

        const result = await login(payload)

        if (result.success) {
          this.showMessage('登录成功', 'success')
          localStorage.setItem('token', result.token)
          localStorage.setItem('user', JSON.stringify(result.user))
          if (this.rememberPassword) {
            this.saveCredentials()
          } else {
            // 如果没有勾选记住密码，清除之前保存的信息
            this.clearSavedCredentials()
          }

          // 跳转到推广页面
          this.$router.push('/promotion')
        } else {
          this.showMessage('登录失败', 'error')
        }
      } catch (error) {
        console.error('登录/注册失败:', error)
        this.showMessage('网络错误，请稍后重试', 'error')
      } finally {
        this.loading = false
      }
    },
    showMessage(text, type) {
      this.message = text
      this.messageType = type
      setTimeout(() => {
        this.message = ''
      }, 3000)
    },
    // 保存登录凭据到localStorage
    saveCredentials() {
      const credentials = {
        positionId: this.loginForm.positionId,
        password: this.loginForm.password,
        rememberPassword: true
      }
      localStorage.setItem('savedCredentials', JSON.stringify(credentials))
    },
    // 从localStorage加载保存的登录凭据
    loadSavedCredentials() {
      try {
        const savedCredentials = localStorage.getItem('savedCredentials')
        if (savedCredentials) {
          const credentials = JSON.parse(savedCredentials)
          if (credentials.rememberPassword) {
            this.loginForm.positionId = credentials.positionId || ''
            this.loginForm.password = credentials.password || ''
            this.rememberPassword = true
          }
        }
      } catch (error) {
        console.error('加载保存的登录信息失败:', error)
        // 如果解析失败，清除可能损坏的数据
        this.clearSavedCredentials()
      }
    },
    // 清除保存的登录凭据
    clearSavedCredentials() {
      localStorage.removeItem('savedCredentials')
    },
    // 切换修改密码状态
    toggleChangePassword() {
      this.showChangePassword = !this.showChangePassword
      this.message = ''
      if (!this.showChangePassword) {
        this.changePasswordForm.newPassword = ''
        this.changePasswordForm.confirmPassword = ''
      }
    },
    // 取消修改密码
    cancelChangePassword() {
      this.showChangePassword = false
      this.changePasswordForm.newPassword = ''
      this.changePasswordForm.confirmPassword = ''
      this.message = ''
    },
    // 处理修改密码
    async handleChangePassword() {
      if (this.changePasswordForm.newPassword !== this.changePasswordForm.confirmPassword) {
        this.showMessage('两次输入的密码不一致', 'error')
        return
      }

      if (this.changePasswordForm.newPassword.length < 6) {
        this.showMessage('密码长度不能少于6位', 'error')
        return
      }

      this.loading = true
      this.message = ''

      try {
        // 调用修改密码的API
        const changeResult = await changePassword({
          positionId: this.loginForm.positionId,
          oldPassword: this.loginForm.password,
          newPassword: this.changePasswordForm.newPassword
        })

        if (changeResult.data && changeResult.data.success) {
          this.showMessage('密码修改成功，正在登录...', 'success')

          // 更新密码到登录表单
          this.loginForm.password = this.changePasswordForm.newPassword

          // 更新保存的密码
          if (this.rememberPassword) {
            this.saveCredentials()
          }

          // 使用新密码执行登录
          await this.performLogin()
        } else {
          this.showMessage('密码修改失败', 'error')
        }

      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.showMessage('密码修改失败', 'error')
        } else {
          this.showMessage('密码修改失败', 'error')
        }
      } finally {
        this.loading = false
      }
    },

    goToRegister() {
      this.$router.push('/register')
    }
  }
}
</script>

<style scoped lang="scss">
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  /* background: linear-gradient(315deg, #88b3a0 0%, #42b983 100%); */
  background: linear-gradient(#42b983 0%, rgba(66, 185, 131, 0.35) 70%, rgba(66, 185, 131, 0.35) 100%);
  padding: 20px;
  box-sizing: border-box;
}

.login-box {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 400px;
}

.login-box h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  font-size: 24px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.form-group label {
  font-weight: 500;
  color: #42b983;
}

/* 设置输入框背景为白色 */
::v-deep .el-input__inner {
  background-color: #fff !important;
  background: #fff !important;
}

::v-deep .el-input__wrapper {
  background-color: #fff !important;
  background: #fff !important;
}

::v-deep .el-input {
  background-color: #fff !important;
  background: #fff !important;
}

::v-deep .el-input__inner:hover {
  background-color: #fff !important;
  background: #fff !important;
}

::v-deep .el-input__inner:focus {
  background-color: #fff !important;
  background: #fff !important;
}

/* 处理浏览器自动填入后的背景色 */
::v-deep .el-input__inner:-webkit-autofill,
::v-deep .el-input__inner:-webkit-autofill:hover,
::v-deep .el-input__inner:-webkit-autofill:focus,
::v-deep .el-input__inner:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #fff inset !important;
  -webkit-text-fill-color: #333 !important;
  background-color: #fff !important;
  background: #fff !important;
  transition: background-color 5000s ease-in-out 0s !important;
}

.form-group input[type="text"],
.form-group input[type="password"] {
  padding: 12px;
  border: 2px solid #e1e5e9;
  border-radius: 5px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-group input[type="text"]:focus,
.form-group input[type="password"]:focus {
  outline: none;
  border-color: #42b983;
}

.remember-group {
  flex-direction: row !important;
  align-items: center;
  justify-content: flex-start;
}

.remember-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  user-select: none;
  color: #42b983;
}

.remember-checkbox {
  margin-right: 8px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  appearance: none;
  border: 2px solid #42b983;
  border-radius: 3px;
  background-color: transparent;
  position: relative;
  transition: all 0.2s ease;
}

.remember-checkbox:checked {
  background-color: #42b983;
  border-color: #42b983;
}

.remember-checkbox:checked::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
}

.login-btn {
  background: linear-gradient(135deg, #42b983 0%, #42b983 100%);
  color: white;
  border: none;
  padding: 12px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.message {
  margin-top: 20px;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  font-weight: 500;
}

.message.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.message.error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* 移动端微调 */
@media (max-width: 480px) {
  .login-container {
    padding: 20px;
  }

  .login-box {
    padding: 24px;
    max-width: 360px;
  }

  .login-box h2 {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .form-group input[type="text"],
  .form-group input[type="password"] {
    padding: 10px;
    font-size: 14px;
  }

  .login-btn {
    padding: 10px;
    font-size: 14px;
  }
}

/* 修改密码表单区域 */
.change-password-section {
  margin-bottom: 15px;
}

/* 记住密码组样式调整 */
.remember-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.remember-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.change-password-label {
  cursor: pointer;
}

/* 修改密码文本样式 */
.remember-text {
  cursor: pointer;
  color: #42b983;
  transition: color 0.3s;
  font-size: 14px;
}

.remember-text:hover {
  color: #369870;
}

/* 密码输入框包装器 */
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.password-input-wrapper input {
  flex: 1;
  padding-right: 40px;
  width: 100%;
}

/* 密码切换按钮 */
.password-toggle {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #666;
  transition: color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-toggle:hover {
  color: #42b983;
}

.password-toggle svg {
  width: 18px;
  height: 18px;
}

.register-link {
  text-align: center;
  margin-top: 20px;
  color: #666;
}

.register-link .el-button {
  color: #42b983;
  font-weight: 500;
}

.register-link .el-button:hover {
  color: #42b983;
}
</style>
